import { render, staticRenderFns } from "./TasksDetail.vue?vue&type=template&id=64dfdf94&scoped=true"
import script from "./TasksDetail.vue?vue&type=script&lang=js"
export * from "./TasksDetail.vue?vue&type=script&lang=js"
import style0 from "./TasksDetail.vue?vue&type=style&index=0&id=64dfdf94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dfdf94",
  null
  
)

export default component.exports